import React from "react";
import { FaBuilding } from "react-icons/fa";

import { PossibleLocations } from "@constants";
import { IconTag } from "./IconTag";

type LocationTagProps = {
  location: string | PossibleLocations;
};

/**
 * An IconTag wrapper to display a time in a tag (rendered by default as a
 * locale string).
 * @param {string|Date} time Time being dislpayed.
 */
export function IconTagLocation({ location, ...delegated }: LocationTagProps) {
  return <IconTag icon={FaBuilding} text={location} {...delegated} />;
}
